import { Check, ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface StepIndicatorProps {
  step: 1 | 2;
  onClickStep1?: () => void;
}

export function StepIndicator({ step, onClickStep1 }: StepIndicatorProps) {
  return (
    <div className="flex items-center gap-2 pt-0.5">
      <button
        type="button"
        className="flex items-center gap-2 group"
        onClick={() => step > 1 && onClickStep1?.()}
        disabled={step === 1}
        style={{ cursor: step > 1 ? "pointer" : "default" }}
      >
        <div className={cn(
          "h-6 w-6 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-colors",
          step > 1
            ? "bg-trend-positive text-background"
            : step === 1
              ? "bg-foreground text-background"
              : "bg-muted-foreground/30 text-foreground/60"
        )}>
          {step > 1 ? <Check className="h-3.5 w-3.5" /> : "1"}
        </div>
        <span className={cn(
          "text-sm font-medium transition-colors",
          step === 1 ? "text-foreground" : "text-muted-foreground group-hover:text-foreground"
        )}>
          Fields
        </span>
      </button>
      <ChevronLeft className="h-3.5 w-3.5 text-muted-foreground rotate-180 shrink-0" />
      <div className="flex items-center gap-2">
        <div className={cn(
          "h-6 w-6 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-colors",
          step > 2
            ? "bg-trend-positive text-background"
            : step === 2
              ? "bg-foreground text-background"
              : "bg-muted-foreground/30 text-foreground/60"
        )}>
          {step > 2 ? <Check className="h-3.5 w-3.5" /> : "2"}
        </div>
        <span className={cn(
          "text-sm font-medium transition-colors",
          step === 2 ? "text-foreground" : "text-muted-foreground"
        )}>
          Configure test
        </span>
      </div>
    </div>
  );
}
